module.exports = __webpack_public_path__ + "img/symbol_12.c0e5b3b2.png";